import {
  ONBOARDING_KYC_ROUTE,
  ONBOARDING_SUITABILITY_ROUTE,
  ONBOARDING_CREATE_ACCOUNT_ROUTE,
  ONBOARDING_FUNDING_ROUTE,
  ONBOARDING_COMPLETE_ROUTE,
} from "_constants";
import { lazy } from "react";
import OnboardingGuard from "./OnboardingGuard";

const OnboardingKYCDocuments = lazy(() => import("pages/onboarding/kyc-documents"));
const OnboardingSuitability = lazy(() => import("pages/onboarding/suitability"));
const OnboardingCreateAccount = lazy(() => import("pages/onboarding/create-account"));
const OnboardingFunding = lazy(() => import("pages/onboarding/funding"));
const OnboardingComplete = lazy(() => import("pages/onboarding/complete"));

export const onboardingRoutes = [
  { path: ONBOARDING_KYC_ROUTE, element: <OnboardingGuard><OnboardingKYCDocuments /></OnboardingGuard> },
  { path: ONBOARDING_SUITABILITY_ROUTE, element: <OnboardingGuard><OnboardingSuitability /></OnboardingGuard> },
  { path: ONBOARDING_CREATE_ACCOUNT_ROUTE, element: <OnboardingGuard><OnboardingCreateAccount /></OnboardingGuard> },
  { path: ONBOARDING_FUNDING_ROUTE, element: <OnboardingGuard><OnboardingFunding /></OnboardingGuard> },
  { path: ONBOARDING_COMPLETE_ROUTE, element: <OnboardingComplete /> },
];
